import _ from 'lodash';

export const sortQuery = (field, direction) =>
  `${direction === 'desc' ? '-' : ''}${field}`;

export const initialSort = data => {
  if (data) {
    const item = data.find(it => !!it.defaultSort);

    if (item) {
      return {
        orderBy: item.field,
        orderDirection: item.defaultSort,
        sort: sortQuery(item.field, item.defaultSort),
      };
    }
  }

  return {};
};

export const parseColumnConfig = (data = []) => {
  let totalWeight = 0;

  data.forEach(({ weight = 1 }) => {
    totalWeight += weight;
  });

  totalWeight = Math.max(1, totalWeight);

  const config = [];
  let totalWidth = 0;

  data.forEach((props, index) => {
    const { sorting = true, sortFunc, weight = 1, align = 'left' } = props;

    const width =
      index < data.length - 1 ? (100 * weight) / totalWeight : 100 - totalWidth;

    totalWidth += width;

    config.push({
      key: props.field || index,
      title: props.title,
      field: props.field,
      render: props.render,
      filtering: props.filtering,
      cellStyle: { padding: '4px 15px', textAlign: align, ...(props.cellStyle || {}) },
      headerStyle: {
        padding: align === 'center' && sorting ? '4px 15px 4px 33px' : '4px 15px',
        textAlign: align,
        userSelect: 'none',
        width: `${width}%`,
      },
      sorting,
      customSort: props.customSort || (sortFunc ? sortFunc(props.field) : undefined),
      dependents: data.filter(it => isDependent(it, props.field)).map(it => it.field),
      initialSort: props.initialSort,
    });
  });

  return config;
};

export const initialState = ({ state, pageSize, columns }) => {
  const config = {
    page: _.get(state, 'page') || 0,
    pageSize: _.get(state, 'pageSize') || pageSize || 5,
    filter: _.get(state, 'filter') || {},
    count: 0,
  };

  const orderBy = _.get(state, 'orderBy');
  const orderDirection = _.get(state, 'orderDirection');

  if (orderBy && orderDirection) {
    config.orderBy = orderBy;
    config.orderDirection = orderDirection;
    config.sort = sortQuery(orderBy, orderDirection);
  } else {
    Object.assign(config, initialSort(columns));
  }

  return config;
};

const isDependent = (data, field) => {
  const dependents = _.get(data, 'filtering.depends');

  return Array.isArray(dependents)
    ? dependents.includes(field)
    : _.isEqual(dependents, field);
};
